// extracted by mini-css-extract-plugin
export default {"container":"CardEscolheMadeira_container__+h-yS"};